"use strict";
/// <reference path="irep.js"/>

IREP.photoshare = (function () {

    var _options;

    var init = function (options) {
        _options = options;

        if (document.documentMode <= 10) {
            configureIEMode();
        }

        initDropBox();
        initGallery();

        //$(window).resizeDebounce({
        //    onResizeEnd: setSidebarHeight,
        //    runOnStart: true,
        //    timeoutDelay: 100
        //});
    };

    var configureIEMode = function () {
        $("#uploadButton").hide();
        $("#dvFileWrapper").show();
        $("#dvFileWrapper").css("width", "500px");
        $("#dvFileWrapper").css("height", "200px");
        $("#dropbox").hide(); 
    }

    var setSidebarHeight = function () {
        var minHeight = $("#dvRightSideHolder").outerHeight(true) + $("#dvContestCountdownMain").outerHeight(true); 
        var availableHeight = $(window).height() - $(footer).height() - $(header).height()
        $("#dvLeftSideHolder").height((availableHeight > minHeight) ? availableHeight : minHeight); //Set height for sidebar 
    };

    var dropbox = $('#dropbox'),
        message = $('.message', dropbox);

    var initGallery = function () {
        if (_options.ContestActive) {
            $("#uploadPhotoButton").show(); //Completely gone. Too easy to bring back
        }
        $(".galleryItem").hover(
            function () {
                $(this).find(".dvHoverHolder").show().css("display", "inline");
            },
            function () {
                $(this).find(".dvHoverHolder").hide();
            }
        );

        $(document).keyup(function (e) {
            if (e.which === 27) { //Pressing escape should close overlays. 
                $("#dvLargeImageOverlay").hide();
                $("#dvPsOverlayHolder").hide();
            }
        });

        $("#btnUploadImage").on("click", function () {
            $(".image-cropper").hide();
            $("#dvConfirmationScreen").show();
        });

        $("#btnClose").on("click", function () {
            $("#dvPsOverlayHolder").hide();
            $("#btnSubmitCrop").click();
        });

        $("#ddlSortOption").on("change", function () {
            sortGallery();
        });

        $(".dvHoverText").on("click", function () {
            enlarge(this);
        });

        $(".winnerImg").on("click", function () {
            enlargeWinner(this); 
        }); 

        $(".dvOrangeVoteBar").on("click", function () {
            if (_options.ContestActive == true) {
                vote(this);
            }
        });
        $("#dvOverlayOrangeBar").on("click", function () {
            if (_options.ContestActive == true) {
                enlargedVote(this);
            }
            return false; 
        });

        $("#btnCloseOverlay").on("click", function () {
            $("#dvLargeImageOverlay").hide();
        });
        $("#dvCloseUploadButton").on("click", function () {
            $("#dvPsOverlayHolder").hide();
        });
        $("#dvCloseUploadButton2").on("click", function () {
            $("#dvPsOverlayHolder").hide();
        });
        $("#dvCloseUploadButton3").on("click", function () {
            $("#dvPsOverlayHolder").hide();
        });

        $("#dvOverlayBackground").on("click", function () {
            $("#dvLargeImageOverlay").hide();
        });
        $("#dvImagePositioner").on("click", function () {
            $("#dvLargeImageOverlay").hide();
        });
        
        $("#uploadButton").on("click", function () { 
            $(':file').click(); //This is to click the $("#uplFile") control
        });

        
        $("#uploadPhotoButton").on("click", function () {
            $("#dvPsOverlayHolder").show();
            $("#dvUserProfileDetails").show();

            $("#dvUploadButtonHolder").hide();
            $(".image-cropper").hide();
            $("#dvConfirmationScreen").hide();
            $("#photoShareOverlay").height($(document).height());

            //Reinitialize - Remove items from previous executions: 
            $(".preview.done").remove();
            $("#dropbox .message").show();
            return false;
        });

        $(".btnUploadNextStep").on("click", function () {
            $("#dvUserProfileDetails").hide();
            $("#dvUploadButtonHolder").show();
            return false; 
        });

        $(".dvBtnApprove").on("click", function () { 
            approveSubmission(this); 
        }); 
        
        $(".dvBtnReject").on("click", function () {
            rejectSubmission(this); 
        });

        if (IREP.options.user.geoCode == "APAC" && IREP.options.user.tier < 4)
        {
            $(".dvOrangeVoteBar").hide();
            $("#dvOverlayOrangeBar").hide();
        }
    };

    var approveSubmission = function (itemClicked) {
        var submissionId = $(itemClicked).attr('data-submissionid');
        IREP.callApi("PhotoShare/Approve", "POST", { submissionId: submissionId, isApproved: true }).done(function () {
            //Refresh page. 
            location.reload();
        }); 

    };
    var rejectSubmission = function (itemClicked) {
        var submissionId = $(itemClicked).attr('data-submissionid');
        IREP.callApi("PhotoShare/Approve", "POST", { submissionId: submissionId, isApproved: false }).done(function () {
            //Refresh page. 
            location.reload();
        });
    };

    var sortGallery = function () {
        window.location = window.location.origin + window.location.pathname + "?sort=" + $("#ddlSortOption").val();
    };

    var enlargeWinner = function (itemClicked) {
        var imgLargeImage = $(itemClicked).attr('data-largeimgurl');
        //Set the overlay height to the same as the document.height, so that we don't have an ugly bottom image. 
        $("#dvLargeImageOverlay").height($(document).height());
        $("#dvImagePositioner").css('top', window.pageYOffset);

        $("#imgLargeImage").attr('src', imgLargeImage);

        $("#dvOverlayOrangeBar").hide();
        $("#dvLargeImageOverlay").show();
    }; 

    var enlarge = function (itemClicked) {
        //Collect values
        var imgLargeImage = $(itemClicked).closest('.galleryItem').attr('data-largeimgurl');
        var submissionId = $(itemClicked).closest('.galleryItem').attr('data-submissionid');
        var hasVote = $(itemClicked).closest('.galleryItem').children('.dvHasVoteOverlay').is(':visible');

        //Set the overlay height to the same as the document.height, so that we don't have an ugly bottom image. 
        $("#dvLargeImageOverlay").height($(document).height());
        $("#dvImagePositioner").css('top', window.pageYOffset);

        $("#imgLargeImage").attr('src', imgLargeImage);
        $("#imgLargeImage").attr('data-submissionid', submissionId);
        $("#dvLargeImageOverlay").show();
        
        if (IREP.options.user.geoCode != "APAC" || IREP.options.user.tier >= 4) {
            $("#dvOverlayOrangeBar").show(); /* Hidden when you enlarge a winner */
        }

        if (hasVote) {
            $("#overlayNoVote").hide();
            $("#overlayHasVote").show();
            $("#dvOverlayOrangeBar p").html(_options.UnvoteText);
        }
        else {
            $("#overlayNoVote").show();
            $("#overlayHasVote").hide();
            $("#dvOverlayOrangeBar p").html(_options.VoteText);
        }
    };

    var enlargedVote = function (itemClicked) {
        var subId = $("#imgLargeImage").attr('data-submissionid');
        var that = this;

        IREP.callApi("Photoshare/Vote", "POST", { submissionId: subId }).done(function (data) {
            var userItem = $('.galleryItem[data-submissionId*=' + subId + ']'); //Find the clicked item on the main page by submissionId value.
            var topNode = userItem.closest('.galleryItem');

            if ($("#overlayHasVote").is(":visible")) {
                $("#overlayNoVote").show();
                $("#overlayHasVote").hide();

                topNode.find('.dvHasVoteOverlay').css('display', 'none');
                topNode.find('.dvVoteCount #dvVoteNum').html(data.numVotes);
                topNode.find(".dvOrangeVoteBar p").html(_options.VoteText);
                $("#dvOverlayOrangeBar p").html(_options.VoteText);
            }
            else {
                $("#overlayNoVote").hide();
                $("#overlayHasVote").show();

                var topNode = userItem.closest('.galleryItem');
                topNode.find('.dvHasVoteOverlay').css('display', 'inline');
                topNode.find('.dvVoteCount').children('#dvVoteNum').html(data.numVotes);
                topNode.find(".dvOrangeVoteBar p").html(_options.UnvoteText);
                $("#dvOverlayOrangeBar p").html(_options.UnvoteText);
            }
        });

        return false; 
    };

    var vote = function (itemClicked) {
        var userItem = itemClicked;
        var subId = $(itemClicked).closest('.galleryItem').attr('data-submissionid');
        IREP.callApi("Photoshare/Vote", "POST", { submissionId: subId }).done(function (data) {
            //Need to display this 'has vote' checkbox. Oh, and increment the count... 
            var topNode = $(userItem).closest('.galleryItem');
            topNode.find('.dvVoteCount #dvVoteNum').html(data.numVotes);
            if (topNode.find('.dvHasVoteOverlay').is(":visible")) {
                topNode.find('.dvHasVoteOverlay').css('display', 'none');
                topNode.find(".dvOrangeVoteBar p").html(_options.VoteText);
            }
            else {
                topNode.find('.dvHasVoteOverlay').css('display', 'inline');
                topNode.find(".dvOrangeVoteBar p").html(_options.UnvoteText);
            }
        });
    };

    var showCropper = function (fileName, fileDisplayName) {
        $("#dvUploadButtonHolder").hide();

        //Remove existing dynamic items if found. (Needed for close & re-open overlay)
        $("#uploadedImage").remove();
        $(".jcrop-holder").remove();
        $(".innerPreview").remove();

        //Append the image to the container. 
        $("#dvUploadedImage").append($("<img id='uploadedImage' class='uploadedImage'>").attr('src', "/api/photoshare/image/" + fileName + "?width=500&height=500&mode=max"));
        
        $("#dvImageUploaded p").html($("#dvImageUploaded p").html().replace("{0}", fileDisplayName)); //Set the name of the file for the confirmation screen

        $("#uploadedImage").bind("load", function () {
            //When the appended element has finished loading, then we want to show the cropper and link it to the uploaded image. 
            // If you do it before, then the 
            $(".image-cropper").show();
            $('.image-cropper').each(linkUp);
        });
        $("#dvUploadedImage").show();

    };

    var initDropBox = function () {
        dropbox.filedrop({
            paramname: 'pic',
            maxfiles: 1,
            maxfilesize: 2, //in MB
            url: 'PhotoShareUpload', //Uses PhotoshareUpload.aspx in the pages\photoshare directory. 

            uploadFinished: function (i, file, response) {
                //Upon upload completion, we want to hide the drop area and show the cropper control. 
                $.data(file).addClass('done');

                showCropper(response[1], response[2]);
            },

            error: function (err, file) {
                switch (err) {
                    case 'BrowserNotSupported':
                        showMessage(_options.ErrorBrowserNotSupported);
                        break;
                    case 'TooManyFiles':
                        alert(_options.ErrorTooManyFiles);
                        break;
                    case 'FileTooLarge':
                        alert(file.name + _options.ErrorFileTooLarge); 
                        break;
                    default:
                        break;
                }
            },

            //Function renders a progress indicator for uploads.
            uploadStarted: function (i, file, len) {
                if (checkFileName(file.name)) {
                    createImage(file);
                }
                else {
                    alert(_options.InvalidFileDetails);
                    return false;
                }
            },

            //Updates the progress bar. 
            progressUpdated: function (i, file, progress) {
                $.data(file).find('.progress').width(progress);
            }

        });
    }

    //Holder for images being uploaded. 
    var template = '<div class="preview">' +
                        '<span class="imageHolder">' +
                            '<img />' +
                            '<span class="uploaded"></span>' +
                        '</span>' +
                        '<div class="progressHolder">' +
                            '<div class="progress"></div>' +
                        '</div>' +
                    '</div>';

    function createImage(file) {

        var preview = $(template),
            image = $('img', preview);

        var reader = new FileReader();

        image.width = 200;
        image.height = 200;

        reader.onload = function (e) {

            // e.target.result holds the DataURL which
            // can be used as a source of the image:
            //alert(e.target.result);
            image.attr('src', e.target.result);
        };

        // Reading the file as a DataURL. When finished,
        // this will trigger the onload function above:
        reader.readAsDataURL(file);

        message.hide();
        preview.appendTo(dropbox);

        // Associating a preview container
        // with the file, using jQuery's $.data():

        $.data(file, preview);
    }

    function showMessage(msg) {
        message.html(msg);
    }

    function linkUp(unusedIndex, container) {
        container = $(container); //We were passed a DOM reference, convert it to a jquery object

        //The code will look for a img.image, a div.preview, a.result, an input.result inside the specified container, and link them together.
        //Only 'img.image' is required, however.  

        //Find the original image
        var image = container.find("img#uploadedImage");

        //Find the aspect ratio of the image
        var targetRatio = $(".croppedPreview").width() / $(".croppedPreview").height();
        var keepRatio = true;

        //jCrop will enforce this ratio:
        var forcedRatio = keepRatio ? targetRatio : null;

        //Find the URL of the original image minus the querystring.
        var path = image.attr('src');
        if (path.indexOf('?') > 0) path = path.substr(0, path.indexOf('?'));

        //Find the preview div(s) (if they exist) and make sure the have a set height and width.
        var divPreview = container.find("div.croppedPreview");

        //What size to make the preview window (defaults to existing width/height if specified in 'style' attribute)
        var previewFallbackWidth = 200;
        var previewFallbackHeight = 200;

        //Allow the div to override the default width and height in the style attribute
        var previewMaxWidth = (divPreview.attr('style') != null && divPreview.attr('style').indexOf('width') > -1) ? divPreview.width() : previewFallbackWidth;
        var previewMaxHeight = (divPreview.attr('style') != null && divPreview.attr('style').indexOf('height') > -1) ? divPreview.height() : previewFallbackHeight;
        //Set the values explicitly.
        divPreview.css({
            width: previewMaxWidth + 'px',
            height: previewMaxHeight + 'px',
            overflow: 'hidden'
        });

        //Create another child div and style it to form a 'clipping rectangle' for the preview div.
        var innerPreview = $('<div />').css({
            overflow: 'hidden'
        }).addClass('innerPreview').appendTo(divPreview);

        //Create a copy of the image inside the inner preview div(s)
        $('<img />').attr('src', image.attr('src')).appendTo(innerPreview);

        //And any input fields (for postbacks, if desired)
        var inputs = container.find('input.result');


        //Create a function to update the link, hidden input, and preview pane
        var update = function (coords) {
            if (parseInt(coords.w) <= 0 || parseInt(coords.h) <= 0) return; //Require valid width and height

            //The aspect ratio of the cropping rectangle. If 'keepRatio', use targetRatio since it's more precise.
            var cropRatio = keepRatio ? targetRatio : (coords.w / coords.h);

            //When the selection aspect ratio changes, the preview clipping area has to also.
            //Calculate the width and height.
            var innerWidth = cropRatio >= (previewMaxWidth / previewMaxHeight) ? previewMaxWidth : previewMaxHeight * cropRatio;
            var innerHeight = cropRatio < (previewMaxWidth / previewMaxHeight) ? previewMaxHeight : previewMaxWidth / cropRatio;

            innerPreview.css({
                width: Math.ceil(innerWidth) + 'px',
                height: Math.ceil(innerHeight) + 'px',
                marginTop: (previewMaxHeight - innerHeight) / 2 + 'px',
                marginLeft: (previewMaxWidth - innerWidth) / 2 + 'px',
                overflow: 'hidden'
            });

            //Calculate how much we are shrinking the image inside the preview window
            var scalex = innerWidth / coords.w;
            var scaley = innerHeight / coords.h;

            //Set the width and height of the image so the right areas appear at the right scale appear.
            innerPreview.find('img').css({
                width: Math.round(scalex * image.width()) + 'px',
                height: Math.round(scaley * image.height()) + 'px',
                marginLeft: '-' + Math.round(scalex * coords.x) + 'px',
                marginTop: '-' + Math.round(scaley * coords.y) + 'px'
            });

            //Calculate the querystring
            var query = '&';

            //Add final size, if specified.
            query += 'maxwidth=' + $(".croppedPreview").width() + '&';
            query += 'maxheight=' + $(".croppedPreview").height() + '&';

            //Add crop rectangle
            query += 'crop=(' + coords.x + ',' + coords.y + ',' + coords.x2 + ',' + coords.y2 + ')&cropxunits=' + image.width() + '&cropyunits=' + image.height();

            //Now, update the links and input values.
            //links.attr('href', "PhotoShareSubmission?name=" + path + query);
            //links.attr('target', '_blank');
            $("#txtRequestString").val("name=" + path + query);
            inputs.attr('value', path + query);
        };


        //Preview window initialization. Based on the aspect ratio, do the initial selection. 
        var sourceRatio = image.width() / image.height();
        var newWidth = divPreview.width();
        var newHeight = divPreview.height();
        var startX = 0;
        var startY = 0;

        //Our viewing area is 300x200. If the ratio of the source image is smaller, then we calculate the display area based on the image width. 
        //      Otherwise, we calculate based on image height. We want to maximize our selection as much as possible. 
        //      X = TargetRatio * Y. 
        if (targetRatio > sourceRatio) {
            newWidth = image.width();
            newHeight = image.width() / targetRatio; //Divide by the ratio because the ratio is width based and we're calculating the Y off the X.
            startX = 0; //We have all the width of the image. Height is the variable
            startY = (image.height() - newHeight) / 2; //Center the crop area.
        }
        else {
            newWidth = image.height() * targetRatio; //Multiply by the ratio because the ratio is width based and we're calculating the X off the Y. 
            newHeight = image.height();
            startX = (image.width() - newWidth) / 2;
            startY = 0; //We have all the height of the image. Width is the variable
        }

        //Start up jCrop
        var jcrop_reference = $.Jcrop(image);
        jcrop_reference.setOptions({
            onChange: update,
            onSelect: update,
            aspectRatio: forcedRatio,
            bgColor: 'black',
            bgOpacity: 0.6
        });

        jcrop_reference.setSelect([startX, startY, newWidth + startX, newHeight + startY]); //Set the initial selection window.
    };

    var fileUploaded = function (sender, args) {
        //Called when the user uploads a file via the 'Choose a file' button. We need to transition to step 2 using the JSON that is sent back. 
        showCropper($.trim($("#dvAsyncUploadGuid").html()), args.get_fileName());
    };

    var checkFileName = function (fileName) {
        var ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        if (ext != "png" && ext != "gif" && ext != "jpg" && ext != "tif" && ext != "bmp") {
            return false; 
        }
        return true; 
    };

    var uploadStarted = function (sender, args) {
        //When the upload starts, validate the file type. Throw an error which results in a popup message for the user that their image is an invalid type. 
        var filename = args.get_fileName();
        if (!checkFileName(filename)) {
            throw { 
                name:        _options.InvalidFileType,
                level:       _options.ErrorText,  
                message:     _options.InvalidFileDetails,
                htmlMessage: _options.InvalidFileDetails 
            }
            return false;
        }
        return true;
    };

    return {
        init: init,
        fileUploaded: fileUploaded,
        uploadStarted: uploadStarted
    };
})();